import { Navigate } from "react-router-dom";

const ProtectedOwnerRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const role  = localStorage.getItem("ownerRole"); // uses ownerRole — never overwritten by admin login

  if (!token || role !== "owner") {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedOwnerRoute;
